import { SafeAreaViewProps } from '@thesisedu/native'
import React from 'react'

/** @deprecated */
export function SafeAreaView({ children }: React.PropsWithChildren<SafeAreaViewProps>) {
  return <>{children}</>
}

export { SafeAreaViewProps } from '@thesisedu/native'
